import { render } from "./AuthIndex.vue?vue&type=template&id=0b3f72d8&scoped=true"
import script from "./AuthIndex.vue?vue&type=script&lang=js"
export * from "./AuthIndex.vue?vue&type=script&lang=js"

import "./AuthIndex.vue?vue&type=style&index=0&id=0b3f72d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3f72d8"]])

export default __exports__